import type { FirestoreContainer } from './FirestoreContainer.js';

import { createContainer } from '@elara/core/di';

import { createClientDestinationModel } from '#models/DestinationModel.js';

/**
 * Client-side Destinations Container for dependency injection.
 *
 * This container manages the creation and registration of the client-side `Destination` model.
 * It ensures that the `Destination` model is properly initialized with its dependencies,
 * such as the Firestore instance.
 */
export function createDestinationsContainer(firestore: FirestoreContainer) {
  const $destinations = createContainer('destinations').providedLazy('ClientDestination', () =>
    createClientDestinationModel(firestore),
  );
  return $destinations;
}

export type $DestinationsContainer = ReturnType<typeof createDestinationsContainer>;
export type DestinationsContainer = $DestinationsContainer['use'];
